var toString = {}.toString;
var getType = function (value) {
  return toString.call(value).replace(/^\[object /, '').replace(/]$/, '');
};
export default getType;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/esm/get-type.js
// module id = 30
// module chunks = 0